<div class="footer-company">
  <app-shared-logo variant="white"></app-shared-logo>
  <p i18n class="company__description">
    Life After Me is a user-friendly platform where you leave all your digital information to your
    loved ones.
  </p>
</div>
